import { BottomNavigation, TemplateWebPages } from "../../components";
import { Center, VStack } from "native-base";
import { platformWeb } from "../../utils";
import { Content } from "./Components/Content";
import { FormContextProvider, NavigatorContextProvider } from "../../contexts";
import { ParamListBase } from "@react-navigation/native";
import { DrawerNavigationProp, DrawerScreenProps } from "@react-navigation/drawer";

export const MovimentSum = ({
  navigation,
}: {
  navigation: DrawerNavigationProp<ParamListBase>;
}) => {
  return (
    <>
      <VStack flex={1}>
        {platformWeb ? (
          <TemplateWebPages navigation={navigation}>
            <Center>
              <Content />
            </Center>
          </TemplateWebPages>
        ) : (
          <>
            <Content />
            <BottomNavigation navigation={navigation} />
          </>
        )}
      </VStack>
    </>
  );
};

export const MovimentSummary = ({ navigation }: DrawerScreenProps<ParamListBase>) => {
  return (
    <NavigatorContextProvider>
      <FormContextProvider>
        <MovimentSum navigation={navigation} />
      </FormContextProvider>
    </NavigatorContextProvider>
  );
};
